import React from "react";

/**
 * icmarkt logo — real SVG from icmarkt.com
 */
export function Logo({ className = "", height = 28, tone = "auto" }) {
  const src = tone === "light" ? "/assets/logo-white.svg" : "/assets/logo.svg";
  return (
    <img
      src={src}
      alt="icmarkt"
      style={{ height, width: "auto" }}
      className={className}
      data-testid="brand-logo"
    />
  );
}

export default Logo;
